const timeoutConfig = {
  debouceTime: 200,
  delayedMenuTime: 500,
};

export default timeoutConfig;
